/** 65262_マンション価格改定対応 2024/10/1～2025/7/31(9ヶ月目)以降削除可能です */
import { selector } from 'recoil';
import { PlanInfoState } from '@/states/planInfoState';
import billingDataState from '@/states/billingDataState';

export type QuitBeforePriceChangedStateType = {
  isQuitBeforePriceState: boolean; // 2024年10月までに解約したユーザへのメッセージ有判定
};

/**
 * マンション価格改定前に解約した契約かどうかを判定する期間限定 selector。
 * 対象プラン・解約状態・請求月を組み合わせ、特定の案内文を出すべき利用者だけを抽出する。
 */
const quitBeforePriceChangedState = selector({
  key: 'quitBeforePriceChangedState',
  get: ({ get }) => {
    const planInfo = get(PlanInfoState);
    const billingData = get(billingDataState);
    let isQuitBeforePriceState: boolean = false;

    if (
      (planInfo.planCode === 'MM001N' || // 対象プラン
        planInfo.planCode === 'MM003N' ||
        planInfo.planCode === 'MM004N' ||
        planInfo.planCode === 'MM005N' ||
        planInfo.planCode === 'MM006N' ||
        planInfo.planCode === 'MM007N' ||
        planInfo.planCode === 'MM008N' ||
        planInfo.planCode === 'MM009N' ||
        planInfo.planCode === 'MM010N' ||
        planInfo.planCode === 'MM011N') &&
      (planInfo.cnStatusCode === 'S07' || planInfo.cnStatusCode === 'S08') && // 解約中・解約完了
      billingData.billing_list.length > 0 // 支払い情報が存在
    ) {
      // 最新請求月が価格改定前であれば、旧価格帯向けの解約案内対象とみなす。
      const thresholdMonth: Date = new Date('2024-10'); // 2024年10月請求まで
      const targetMonth: Date = new Date(
        [...billingData.billing_list].at(0)?.billing_month as string // 比較する年月
      );

      if (targetMonth <= thresholdMonth) {
        isQuitBeforePriceState = true; // 対象ブラン・解約・日付が条件一致した場合
      }
    }
    return {
      isQuitBeforePriceState,
    };
  },
});

export { quitBeforePriceChangedState };
/** 65262_マンション価格改定 [ここまで] ファイル削除OK */
